import { AppStatsQAPlatformKey, VaultPlatformKey, VaultPlatformLabel } from './FamilyConstants';

function getStatAppLabel(appKey, appFamily) {
    if (appKey === VaultPlatformKey) {
        return VaultPlatformLabel;
    }
    if (appKey === appFamily.key) {
        return appFamily.label;
    }
    return appFamily.applications.find((a) => a.key === appKey)?.label;
}

/**
 * Retrieves stats for the family that are active and not platform only (for app families) for the filter dialog dropdown
 * @param families all families
 * @param family the family the stats will be from
 * @returns formatted stats for the filter dialog that includes label, stat key, stat type, and a compound key
 */

export default function getAllStatsForFilter(families, family) {
    return (
        families?.flatMap((f) => {
            if (f.key !== family.key && f.key !== family.platform_family_key) {
                return [];
            }

            return Object.entries(f.stat_metadata).flatMap(([appKey, currentSectionMetadata]) =>
                Object.entries(currentSectionMetadata)
                    .filter(
                        ([, currentStat]) =>
                            currentStat.status === 'ACTIVE' &&
                            (family.key === family.platform_family_key ||
                                currentStat.scope !== 'PLATFORM_ONLY') &&
                            (family.key === AppStatsQAPlatformKey
                                ? appKey === AppStatsQAPlatformKey
                                : true),
                    )
                    .map(([key, currentStat]) => ({
                        statKey: key,
                        label: `${getStatAppLabel(appKey, f)} > ${currentStat.label}`,
                        type: currentStat.type,
                        compoundKey: `${appKey}_${key}`,
                    })),
            );
        }) || []
    );
}
